module.exports = __webpack_public_path__ + "img/bariloche.8c461e1d.jpg";